<template>
  <div class="cfo-decisions-history">
    <div class="history-header">
      <h3 class="history-title">待决策事项历史</h3>
      <span class="history-count">共 {{ records.length }} 条记录</span>
    </div>
    <div class="history-list">
      <div
        v-for="(item, index) in records"
        :key="index"
        class="history-card"
      >
        <div class="card-top">
          <div class="card-title-h">{{ item.title }}</div>
          <div class="card-meta">
            <span class="priority-tag" :class="`priority-tag--${item.priority}`">{{ item.priorityLabel }}</span>
            <span class="card-owner">{{ item.owner }}</span>
            <span class="card-deadline">截止:{{ item.deadline }}</span>
          </div>
        </div>
        <div class="card-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
const DECISIONS_HISTORY = [
  {
    title: '是否启动内单客户涨价4%专项',
    priority: 'high',
    priorityLabel: '高优先',
    owner: '张伟（销售部）',
    deadline: '2026-06-25',
    desc: '市场端，影响+286万，需CFO确认客户策略边界。已与3家核心内单客户初步沟通。'
  },
  {
    title: '产能资源分配优先级调整',
    priority: 'medium',
    priorityLabel: '中优先',
    owner: '王强（制造部）',
    deadline: '2026-06-26',
    desc: '利用率72%→85%目标，需确认产线排程与人员配置方案。'
  },
  {
    title: 'PCB/铜/锡替代料紧急采购审批',
    priority: 'high',
    priorityLabel: '高优先',
    owner: '李莉（采购部）',
    deadline: '2026-06-24',
    desc: '启动替代料验证与紧急采购流程，预计增加采购成本约3-5%。'
  },
  {
    title: '质量损失红线治理专项启动',
    priority: 'high',
    priorityLabel: '高优先',
    owner: '王强（质量部）',
    deadline: '2026-06-25',
    desc: '返工率从2.1%升至4.3%，需启动专项治理并明确KPI考核标准。'
  }
]

export default {
  name: 'CfoDecisionsHistory',
  data() {
    return {
      records: DECISIONS_HISTORY
    }
  }
}
</script>

<style lang="scss" scoped>
.cfo-decisions-history {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 20px;
  overflow: hidden;
  background: #fff;
}

.history-header {
  margin-bottom: 12px;
  flex-shrink: 0;
}

.history-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px;
}

.history-count {
  font-size: 11px;
  color: #94a3b8;
}

.history-list {
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;
}

.history-card {
  padding: 12px 14px;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 6px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: rgba(74, 95, 243, 0.3);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.card-top {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 4px;
}

.card-title-h {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.5;
  text-align: left;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.priority-tag {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;

  &--high {
    background: #fef2f2;
    color: #e54b3d;
  }

  &--medium {
    background: #fff7ed;
    color: #d98213;
  }
}

.card-owner {
  font-size: 11px;
  color: #64748b;
}

.card-deadline {
  font-size: 11px;
  color: #94a3b8;
}

.card-desc {
  font-size: 11px;
  color: #64748b;
  line-height: 1.5;
  text-align: left;
}
</style>
